import { render } from "./Folder.vue?vue&type=template&id=9e1dbae0"
import script from "./Folder.vue?vue&type=script&lang=js"
export * from "./Folder.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "9e1dbae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e1dbae0', script)) {
    api.reload('9e1dbae0', script)
  }
  
  module.hot.accept("./Folder.vue?vue&type=template&id=9e1dbae0", () => {
    api.rerender('9e1dbae0', render)
  })

}

script.__file = "src/icons/components/filled/Folder.vue"

export default script